module.exports = "https://cdn.dashboard.gifty.nl/5680/images/logo-christmas.svg?b865672ae71a30db525e8c60cc81443b";